module.exports = __webpack_public_path__ + "static/media/archive.9334f644.svg";